<template>
  <base-section
    id="tss"
  >
    <base-section-heading
      title="Test Spring School 2023"
    />
    <v-container>
      <base-section-heading
      divider=null
      >
      <span style="color: red"><strong>The official website for the Test Spring School 2023 is now available at this <a
      href="https://tss.date.upb.de/tss2023/"
      target="_blank"
      >
       link.</a> </strong></span><br>
        Ph.D. students interested in testing topics can attend the TSS (limited seats – first come, first serve). It will be held from 19 to 22 of May in Rifugio Donzella - Gorino Sullam (RO) - Italy.
      </base-section-heading>
      <br>
      <v-row>
        <base-avatar-card
          title="Test Spring School Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(contest, i) in contests"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="contest"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in studentsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < studentsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Tss',

    data: () => ({
      isMobile: false,
      studentsfooter: [
        {
          name: 'Student Activities at ETS23',
          url: 'student-activities-23',
        },
        {
          name: 'Best Student Presentation Award',
          url: 'bspa',
        },
        {
          name: 'PhD Forum',
          url: 'student-phd-forum',
        },
        {
          name: 'McCluskey Award',
          url: 'mccluskey',
        },
        {
          name: 'Test Spring School',
          url: 'tss',
        },
        {
          name: 'Student Activities at ETS22',
          url: 'student-activities-22',
        },
      ],
      contests: [
        {
          title: 'Haralampos Stratigopoulos',
          src: require('@/images/committees/haralamposstratigopoulos.jpg'),
          text: 'Sorbonne University, FR',
        },
        {
          title: 'Ioana Vatajelu',
          src: require('@/images/committees/ioanavatajelu.jpg'),
          text: 'Grenoble-Alpes University, FR',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
